<router-outlet *ngIf="!loading"></router-outlet>
<ng-snotify></ng-snotify>

<img
  class="w-screen h-screen absolute top-0 theme-light p-10 z-[100]"
  src="assets/404.svg"
  alt=""
  *ngIf="notFound" />
